import { render, staticRenderFns } from "./printHandover.vue?vue&type=template&id=cd57e53e&scoped=true"
import script from "./printHandover.vue?vue&type=script&lang=js"
export * from "./printHandover.vue?vue&type=script&lang=js"
import style0 from "./printHandover.vue?vue&type=style&index=0&id=cd57e53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd57e53e",
  null
  
)

export default component.exports